import axios, { pluckData } from 'src/utilities/http-client'
import { LifecycleState } from 'src/v3/core/types'

type CourseLifecycleTransitionResponse = {
  id: string
  courseID: string
  fromState: LifecycleState
  toState: LifecycleState
  actorID: string | null
  transitionSource: 'Manual' | 'CAPCEExpiration'
  createdTime: string
  updatedTime: string
}

let post = (courseId: string, action: string) =>
  axios
    .post<CourseLifecycleTransitionResponse>(
      `/api/pipeline/compliance-course/${courseId}/${action}`,
    )
    .then(pluckData)

export let preArchiveCourse = (courseId: string) =>
  post(courseId, 'pre-archive')
export let reactivateCourse = (courseId: string) => post(courseId, 'reactivate')
export let archiveCourse = (courseId: string) => post(courseId, 'archive')
export let restoreCourse = (courseId: string) => post(courseId, 'restore')
